export const formAction = {
  path: "/form_action",
  name: "form_action",
  hidden: false,
  component: () => import("@/components/formAction/index"),
  meta: {
    title: "Form Tindakan",
    icon: "",
    roles: [""]
  }
};
export default formAction;



// WEBPACK FOOTER //
// ./src/router/modules/formAction.js